import { useContext } from 'react';
import { AuthContext } from '../context/auth-context';

/** A sessão e as operações de login. Só existe abaixo do `AuthProvider`. */
export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
}
